export const environment = {
  production: true,
  userBaseUrl: 'https://auth.tsin.ca/api',
  userMgtUrl: 'https://portal1.tsin.ca/login/work-with-us',
  apiBaseUrl: 'https://ukammvdjzt.us-east-1.awsapprunner.com/api',
  paymentUrl: 'https://payment-prod.tsin.ca',
  userMgtCreateUrl: 'https://portal1.tsin.ca/create-account/work-with-us',
  authBaseUrl: 'https://zxkbbj3pcy.us-east-1.awsapprunner.com/api',
  learningBaseUrl: 'https://learn-be.tsin.ca/api',
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
};
